/**
 * localStorage-обёртка для активного воркспейса (свитчер мультитенантности).
 *
 * Идентификатор активного воркспейса нужен axios-перехватчику `@api/meerec/client`,
 * который шлёт его заголовком `X-Workspace-Sid` — так backend изолирует коммуникации
 * по выбранной компании. Хранится отдельно от jotai-атома, чтобы перехватчик мог
 * читать значение синхронно вне React-дерева.
 */

const STORAGE_KEY = 'colver:active-workspace';

/** Прочитать id активного воркспейса (или `null`). */
export const readActiveWorkspaceId = (): string | null => {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

/** Сохранить id активного воркспейса. */
export const writeActiveWorkspaceId = (id: string): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch {
    // ignore quota / disabled storage
  }
};

/** Стереть выбор активного воркспейса. */
export const clearActiveWorkspaceId = (): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
